var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * 默认属性
 * @hidden
 */
export var DEFAULT_ATTRIBUTES = {
    path: '/',
};
/**
 * 敏感符号转换
 * ; <=> %3B
 * @hidden
 */
var converter = {
    read: function (value) {
        return value.replace(/%3B/g, ';');
    },
    write: function (value) {
        return value.replace(/;/g, '%3B');
    },
};
/**
 * 设置 Cookie
 *
 * ```js
 * FastUtils.setCookie('key', 'value'); // => key=value; path=/;
 *
 * // 有效期7天
 * FastUtils.setCookie('key', 'value', { expires: 7 }); // => key=value; path=/; expires=Fri, 26 Jun 2020 08:26:36 GMT;
 *
 * // 在本域名以及所有子域名下有效
 * FastUtils.setCookie('key', 'value', { domain: '.yourDomain.com' });
 * ```
 *
 * @category Cookie
 * @param key
 * @param value
 * @param attributes
 * @returns The cookie string assigned to document.cookie
 */
function setCookie(key, value, attributes) {
    if (!key)
        return '';
    attributes = __assign(__assign({}, DEFAULT_ATTRIBUTES), attributes);
    // if (typeof attributes.expires === 'number') {
    //   attributes.expires = new Date(Date.now() + attributes.expires * 864e5).toUTCString();
    // }
    key = converter.write(key).replace(/=/g, '%3D');
    value = converter.write(value);
    var stringifiedAttributes = '';
    Object.keys(attributes).forEach(function (attributeName) {
        var attributeValue = attributes[attributeName];
        if (!attributeValue)
            return;
        stringifiedAttributes += '; ' + attributeName;
        if (attributeValue === true)
            return;
        if (attributeName === 'expires' && typeof attributeValue === 'number') {
            // 将过期天数转换成UTC时间字符串
            var expireDate = new Date(Date.now() + attributeValue * 864e5).toUTCString();
            return (stringifiedAttributes += '=' + expireDate.split(';')[0]);
        }
        stringifiedAttributes += '=' + attributeValue.split(';')[0];
    });
    return (document.cookie = key + '=' + value + stringifiedAttributes);
}
/**
 * 获取 Cookie
 *
 * ```js
 * FastUtils.getCookie('key'); // => 'value'
 * FastUtils.getCookie('nothing'); // => undefined
 *
 * // 获取所有 cookie
 * FastUtils.getCookie(); // => { key: 'value' }
 * ```
 *
 * @category Cookie
 * @param key
 */
function getCookie(key) {
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var cookiesData = {};
    for (var i = 0; i < cookies.length; i++) {
        var parts = cookies[i].split('=');
        var value = parts.slice(1).join('=');
        var foundKey = converter.read(parts[0]).replace(/%3D/g, '=');
        cookiesData[foundKey] = converter.read(value);
        if (key === foundKey) {
            break;
        }
    }
    if (key) {
        return cookiesData[key];
    }
    return cookiesData;
}
/**
 * 删除 Cookie
 *
 * ```js
 * FastUtils.setCookie('key', 'value');
 * FastUtils.removeCookie('key');
 * FastUtils.getCookie('key'); // => undefined
 *
 * // 删除指定 domain / path 下的 Cookie 的正确方式
 * FastUtils.setCookie('key', 'value', { domain: '.yourDomain.com', path: '/a' });
 *
 * FastUtils.removeCookie('key'); // × 错误示范
 * FastUtils.getCookie('key'); // => 'value' 这样是删除不了的
 *
 * FastUtils.removeCookie('key', { domain: '.yourDomain.com', path: '/a' });
 * FastUtils.getCookie('key'); // => undefined 删除了
 * ```
 *
 * @category Cookie
 * @param key
 * @param attributes
 * @returns Cookie string removed from document.cookie
 */
function removeCookie(key, attributes) {
    return setCookie(key, '', __assign(__assign({}, (attributes || {})), { expires: -1 }));
}
export { setCookie, getCookie, removeCookie };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ali/fast-utils/dist/cookie.js
// module id = null
// module chunks = 